import { Card, CardBody, Col, Row, NavItem, NavLink } from "reactstrap";

const LoadingOnboarding = () => {
    return (
        <Card className="ai-onboarding-loading-component">
            <CardBody>
                <Row>
                    <Col sm='12'>
                        <div className="bg-transparent wizard-steps-container shadow-none ai-onboarding-wizard">
                            <div className="twitter-bs-wizard">
                                <ul className="twitter-bs-wizard-nav nav-justified nav nav-pills">
                                    <NavItem>
                                        <NavLink className="active">
                                            <span className="step-number">
                                                <div className="dt-field dt-skeleton"></div>
                                            </span>

                                            <span className="step-title">
                                                <div className="dt-field dt-skeleton"></div>
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink>
                                            <span className="step-number">
                                                <div className="dt-field dt-skeleton"></div>
                                            </span>

                                            <span className="step-title">
                                                <div className="dt-field dt-skeleton"></div>
                                            </span>
                                        </NavLink>
                                    </NavItem>

                                    <NavItem>
                                        <NavLink>
                                            <span className="step-number">
                                                <div className="dt-field dt-skeleton"></div>
                                            </span>

                                            <span className="step-title">
                                                <div className="dt-field dt-skeleton"></div>
                                            </span>
                                        </NavLink>
                                    </NavItem>
                                </ul>
                            </div>
                        </div>
                    </Col>
                    <Col sm='12'>
                        <div className="ai-onboarding-alert d-flex justify-content-start align-items-center">
                            <div className="alert-icon">
                                <div className="dt-field dt-skeleton"></div>
                            </div>

                            <div className="alert-content">
                                <h4><div className="dt-field dt-skeleton"></div></h4>

                                <p>
                                    <div className="dt-field dt-skeleton"></div>
                                </p>
                            </div>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Card>
    )
}

export default LoadingOnboarding